import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectionListChange } from '@angular/material/list';
import * as _ from 'lodash';
import { Client } from 'src/app/domain/client';
import { UserService } from 'src/app/services/user.service';


@Component({
    selector: 'app-client-box',
    templateUrl: './client-selection-box.html',
    styleUrls: ['./client-selection-box.scss']
})
export class ClientSelectionBoxDialog implements OnInit {

    searchText: string = '';


    public Client: Client = new Client();
    alreadyAssignedList: Client[] = [];

    public AvailableClientList: Client[] = [];

    SelectedClientList: Client[] = [];


    constructor(
        private userService: UserService,
        public dialogRef: MatDialogRef<ClientSelectionBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        if (data.client) {
            this.Client = Object.assign({}, data.client);
        } else {
            this.alreadyAssignedList = data.alreadyAssignedList;
        }
    }

    ngOnInit() {

    }

    searchNewClient() {
        this.userService.getClientList(this.searchText).subscribe(x => {
            this.AvailableClientList = _.differenceBy(x, this.alreadyAssignedList, x => x.Code);
            this.AvailableClientList = _.sortBy(this.AvailableClientList, [
                function(item) { return item.Name; },
              ]);
        });
    }

    setSelectedClients(event: MatSelectionListChange) {
        if (event.options[0].selected) {
            this.SelectedClientList.push(...event.options.filter(e => e.selected).map(x => x.value));
        } else {
            _.remove(this.SelectedClientList, x => x.Code === event.options[0].value.Code)
        }
    }

    CanAdd() {
        return this.SelectedClientList.length >= 1;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.SelectedClientList);
    }
}
